var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "table-content",
          attrs: {
            stripe: "",
            data: _vm.tableData,
            height: _vm.tableMaxHeight,
            id: "table",
            "header-cell-style": this.$globalGrayTableHeaderStyle,
            border: "",
          },
          on: {
            "filter-change": _vm.filterChange,
            "sort-change": _vm.sortChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              width: "50",
              align: "center",
              "show-overflow-tooltip": true,
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "接收状态",
              prop: "receivingStatusName",
              "header-align": "center",
              align: "center",
              "min-width": "80",
              fixed: "left",
              "show-overflow-tooltip": true,
              filters: [
                { text: "待接收", value: "statusCondition_1" },
                { text: "已接收", value: "statusCondition_2" },
                { text: "已失效", value: "statusCondition_3" },
              ],
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("i", {
                      class: _vm.formatterStatusClass(
                        scope.row.receivingStatus
                      ),
                    }),
                    _c("span", [_vm._v(_vm._s(scope.row.receivingStatusName))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "文号",
              prop: "documentNumber",
              align: "left",
              "min-width": "100",
              "show-overflow-tooltip": true,
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "文件名称",
              prop: "documentName",
              align: "left",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "发送部门",
              prop: "createDeptName",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "custom-header" },
                      [
                        _c("span", [_vm._v("发送部门")]),
                        _c(
                          "el-popover",
                          { attrs: { width: "300", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-section" },
                              [
                                _c("p", [_vm._v("请输入")]),
                                _c("el-input", {
                                  attrs: { clearable: "" },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.customFn(3)
                                    },
                                  },
                                  model: {
                                    value: _vm.createDeptName,
                                    callback: function ($$v) {
                                      _vm.createDeptName = $$v
                                    },
                                    expression: "createDeptName",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "custom-section--btns" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.customFn(1)
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.customFn(3)
                                          },
                                        },
                                      },
                                      [_vm._v("确定")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-search",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "发送时间",
              prop: "releaseTime",
              "header-align": "center",
              align: "center",
              "min-width": "160",
              "show-overflow-tooltip": true,
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "接收部门",
              prop: "receivingDeptName",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "custom-header" },
                      [
                        _c("span", [_vm._v("接收部门")]),
                        _c(
                          "el-popover",
                          { attrs: { width: "300", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-section" },
                              [
                                _c("p", [_vm._v("请输入")]),
                                _c("el-input", {
                                  attrs: { clearable: "" },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.customFn(2)
                                    },
                                  },
                                  model: {
                                    value: _vm.receivingDeptName,
                                    callback: function ($$v) {
                                      _vm.receivingDeptName = $$v
                                    },
                                    expression: "receivingDeptName",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "custom-section--btns" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.customFn(1)
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.customFn(2)
                                          },
                                        },
                                      },
                                      [_vm._v("确定")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-search",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          "open-delay": 800,
                          effect: "dark",
                          content: scope.row.receivingDeptName,
                          placement: "top",
                          "popper-class": "popper-class",
                        },
                      },
                      [
                        _c("p", { staticClass: "issus-slot" }, [
                          _vm._v(_vm._s(scope.row.receivingDeptName)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "接收时间",
              prop: "receiveTime",
              "header-align": "center",
              align: "center",
              "min-width": "160",
              "show-overflow-tooltip": true,
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              "header-align": "left",
              align: "left",
              fixed: "right",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.receivingStatus != 3 &&
                    _vm.hasBtnPermission("btn_officalDocProcess_view")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              title: "查看",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }